export default {
  content: `<p>
    <span style="color: #548DD4;">China's computing power development has formed a trillion-yuan industrial landscape characterized by "intelligent computing power as the dominant force and a nationwide integrated computing network as the core"</span>. Relying on the "East Data, West Computing" strategy, China is deeply integrating computing power with electricity to transform it into a public infrastructure as readily available as "water and electricity."
</p>
<p>
    <span style="font-size: 18px;"><strong>Current Status of Computing Power Development</strong></span>
</p>
<ul class=" list-paddingleft-2" style="list-style-type: disc;">
    <li>
        <p>
            <strong>Explosive Growth in Intelligent Computing Scale</strong>: As of the end of March 2026, China's built intelligent computing power scale reached 1.882 million P (equivalent to 1882 EFLOPS), achieving a 2.5-fold leapfrog growth year-over-year, with intelligent computing power becoming the absolute main driver of incremental growth.
        </p>
    </li>
    <li>
        <p>
            <strong>"8+10+3" Spatial Layout Established</strong>: The spatial structure centered on 8 national computing power hubs, 10 national data center clusters, and 3 computing-electricity collaborative development zones has been fully established, achieving intensive and large-scale development of national computing power resources.
        </p>
    </li>
    <li>
        <p>
            <strong>"20-millisecond Latency Circle" Achieved</strong>: 145 backbone optical cables have been built between hubs, and the network transmission latency from all provinces to the 8 hubs has been reduced to within 20 milliseconds, making the "thousands of miles away, instant arrival" computing-network integration a reality.
        </p>
    </li>
    <li>
        <p>
            <strong>Applications Shift from "Training" to "Inference" and Accelerate Downward</strong>: With the comprehensive deployment of large models, intelligent computing centers are transitioning from being dominated by large model "training" to "inference," and computing power is deeply empowering industries such as manufacturing, transportation, and government services.
        </p>
    </li>
    <li>
        <p>
            <strong>Core Practical Challenges</strong>: There is a structural mismatch in computing power supply. Some western nodes face concerns of "built but unused and low utilization" due to weak physical infrastructure, while high-end and highly reliable computing power in the east remains tight. At the same time, there is still room for breakthroughs in independent innovation of high-end AI chips.
        </p>
    </li>
</ul>
<p>
    <br/>
</p>`,
};